@if (mode === 'renderer') {
  <div
    class="grid-view"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor
    }"
  >
    <div
      class="dynamic-grid"
      [class.dynamic-grid--edit]="edit"
      [style.--bs-gutter-x.px]="element.fields.gap"
      [ngStyle]="{
      '--cols': element.fields.cols,
      '--tablet-cols': element.fields.tabletCols,
      '--mobile-cols': element.fields.mobileCols,
      '--gap': element.fields.gap + 'px'
      }"
    >
      <div class="flex-fill" *ngFor="let colIndex of [].constructor(element.fields.cols); let i = index">
        <div
          class="element-wrapper"
          *ngFor="let comp of element.fields['colGrid' + i]; let j = index"
          (click)="edit ? onElementClick(comp, $event) : null"
          [class.active-element]="dynamicPageEditorHelperService.editElementInGrid === comp && edit"
        >
          @if (edit) {
            <div class="element-toolbar">
              <div class="element-toolbar-left">
                <span class="el-type-label">{{ dynamicPagesService.getComponentNameById(comp.id) }}</span>
              </div>
              <div class="element-toolbar-right">
                <button class="el-btn" (click)="moveUp(i, j); $event.stopPropagation()" title="Move up"><i class="fa-solid fa-arrow-up"></i></button>
                <button class="el-btn" (click)="moveDown(i, j); $event.stopPropagation()" title="Move down"><i class="fa-solid fa-arrow-down"></i></button>
                <button class="el-btn" (click)="moveRight(i, j); $event.stopPropagation()" title="Move right"><i class="fa-solid fa-arrow-right"></i></button>
                <button class="el-btn" (click)="moveLeft(i, j); $event.stopPropagation()" title="Move left"><i class="fa-solid fa-arrow-left"></i></button>
                <button class="el-btn" (click)="copy(i, j); $event.stopPropagation()" title="Copy"><i class="fa-solid fa-copy"></i></button>
                <button class="el-btn el-btn--danger" (click)="deleteElement(i, j); $event.stopPropagation()" title="Delete"><i class="fa-solid fa-trash"></i></button>
              </div>
            </div>
          }

          <ng-container
            *ngComponentOutlet="
              dynamicPagesService.getComponentById(comp.id);
              inputs: { element: comp, mode: 'renderer', edit: edit }
            "
          >
          </ng-container>
        </div>

        <!-- Dropzone -->
        @if (edit) {
          <div
            class="dp-dropzone"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event, i)"
          >
            <div class="dp-dropzone-hint">
              <i class="fa-solid fa-circle-plus"></i>
              <span>Drop element here</span>
            </div>
            @if (dynamicPageEditorHelperService.copy) {
              <button class="dp-paste-btn" (click)="paste(i)">
                <i class="fa-solid fa-paste"></i>
                <span>{{ 'Paste' | translate }}</span>
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="properties-cp-grid">
            <ng-container *ngIf="dynamicPageEditorHelperService.editElementInGrid && dynamicPageEditorHelperService.editElementInGrid !== element; else noSelection">
              <div class="element-name-title">
                {{ dynamicPagesService.getComponentNameById(dynamicPageEditorHelperService.editElementInGrid.id) }}
              </div>
              <ng-container
                *ngComponentOutlet="
                  dynamicPagesService.getComponentById(dynamicPageEditorHelperService.editElementInGrid.id);
                  inputs: { element: dynamicPageEditorHelperService.editElementInGrid, mode: 'editor' }
                "
              >
              </ng-container>
            </ng-container>
            <ng-template #noSelection>
              <p>Select component in grid to edit.</p>
            </ng-template>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-6">
              <lib-gung-number-input
                [gungTranslate]="'COLS'"
                [(ngModel)]="element.fields.cols"
                maxValue="12"
                (ngModelChange)="createComponentsCols()"
              ></lib-gung-number-input>
            </div>
            <div class="col-6">
              <lib-gung-number-input
                [gungTranslate]="'GAP px'"
                [(ngModel)]="element.fields.gap"
              ></lib-gung-number-input>
            </div>
            <div class="col-6">
              <lib-gung-number-input
                [gungTranslate]="'Tablet Cols Per Row'"
                [(ngModel)]="element.fields.tabletCols"
                maxValue="12"
              ></lib-gung-number-input>
            </div>
            <div class="col-6">
              <lib-gung-number-input
                [gungTranslate]="'Mobile Cols Per Row'"
                [(ngModel)]="element.fields.mobileCols"
                maxValue="12"
              ></lib-gung-number-input>
            </div>
            <div class="col-12">
              <lib-dynamic-page-element-margin-padding
                [(marginTop)]="element.fields.marginTop"
                [(marginRight)]="element.fields.marginRight"
                [(marginBottom)]="element.fields.marginBottom"
                [(marginLeft)]="element.fields.marginLeft"
                [(paddingTop)]="element.fields.paddingTop"
                [(paddingRight)]="element.fields.paddingRight"
                [(paddingBottom)]="element.fields.paddingBottom"
                [(paddingLeft)]="element.fields.paddingLeft"
              ></lib-dynamic-page-element-margin-padding>
            </div>
            <div class="col-12 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input
                  [gungTranslate]="'BACKGROUND_COLOR'"
                  [(ngModel)]="element.fields.backgroundColor"
                ></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="text-center grid-preview"><i class="fa-solid fa-columns-3"></i></div>
}
